import { render, staticRenderFns } from "./CurriculumData.vue?vue&type=template&id=a6c27d2a&"
import script from "./CurriculumData.vue?vue&type=script&lang=js&"
export * from "./CurriculumData.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports